import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import Img from './Img';
import defaultPropValues from '../helper/defaultPropValues';

const Image = (props) => {
	const data = { ...defaultPropValues.imageProps.data, ...props.data };
	const { path, alt } = data;
	const labels = useLabels();

	return (
		<div className="ws-content-rows-image">
			<Img className="m-auto" src={path} alt={labels.get(alt)} />
		</div>
	);
};

export const ImageProps = {
	data: propTypes.shape({
		path: propTypes.string.isRequired,
		alt: propTypes.string
	}).isRequired
};
Image.propTypes = ImageProps;

export default Image;
